import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const GuestTrackerProtectedRoute = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const location = useLocation();

  useEffect(() => {
    if (!user) {
      navigate("/guest-tracker-login", {
        state: { from: location },
        replace: true,
      });
    }
  }, [user, navigate, location]);

  return null;
};

export default GuestTrackerProtectedRoute;
